<template>
</template>

<script>
export default {
  name: 'Publications',
  components: {},
  props: ['lang'],
  created() {
  },
  data() {
    return {
      //lang: this.$route.query.lang || 'en',
      contents: [
        {
        order: 1000,
        type: 'publication',
        title: "Publications",
        icon: ['researcher'],
        style_title: "info-regular",
        style_content: "info-regular-pub",
        content: [
          {
            title: {
              en: "Rotational Drive-Versus-Quality and Video Compression-Versus-Delay Analysis for Multi-Channel Video Streaming System on Ground Combat Vehicles",
              ko: "지상 전투 차량을 위한 다채널 영상 스트리밍 시스템의 회전 구동 대비 품질과 압축 대비 지연 분석"
            },
            author: {
              en: "Jihyeok Yun, <b>Younggeol Cho</b>, Hyemin Chang",
              ko: "윤지혁, <b>조영걸</b>, 장혜민"
            },
            journal: {
              en: "Journal of the Korea Institute of Military Science and Technology",
              ko: "한국군사과학기술학회지"
            },
            page: "Vol. 24, No. 1, pp. 31-40",
            year: "Feb. 2021"
          },
          {
            title: {
              en: "System Error Analysis and Position Accuracy Improvement in Networked Drive Control System for Synchronization",
              ko: "구동장치 동기화를 위한 네트워크 기반 제어 시스템 오차 분석 및 위치 정확도 향상 기법"
            },
            author: {
              en: "<b>Younggeol Cho</b>, Jihyeok Yun, Hyemin Chang",
              ko: "<b>조영걸</b>, 윤지혁, 장혜민"
            },
            journal: {
              en: "The Journal of Korean Institute of Information Technology",
              ko: "한국정보기술학회논문지"
            },
            page: "Vol. 19, No. 4, pp. 63-73",
            year: "Apr. 2021",
            doi: "10.14801/jkiit.2021.19.4.63",
            link: "https://doi.org/10.14801/jkiit.2021.19.4.63"
          },
          {
            title: "Development of an Information Security-Enforced EEG-Based Nuclear Operators’ Fitness for Duty Classification System",
            author: "Jung Hwan Kim, <b>Younggeol Cho</b>, Young A Suh, Man-Sung Yim",
            journal: "IEEE Access",
            page: "Vol. 9, pp. 72535-72546",
            year: "May. 2021",
            doi: "10.1109/ACCESS.2021.3078470",
            link: "https://doi.org/10.1109/ACCESS.2021.3078470",
            etc: "(SCIE, IF=3.745)"
          },
          {
            title: {
              en: "Plug-and-Play Framework for Connectivity Control and Self-Reconfiguration of Weapon System Components",
              ko: "무기체계 구성장치의 연결성 제어 및 자율 재구성을 위한 플러그앤플레이 프레임워크"
            },
            author: {
              en: "Hyemin Chang, Sukjong Kang, <b>Younggeol Cho</b>, Joohong Yoon, Jihyeok Yun",
              ko: "장혜민, 강석종, <b>조영걸</b>, 윤주홍, 윤지혁"
            },
            journal: {
              en: "Journal of the Korea Institute of Military Science and Technology",
              ko: "한국군사과학기술학회지"
            },
            page: "Vol. 24, No. 3, pp. 328-338",
            year: "Jun. 2021"
          },
        ]
      },
        {
          order: 1100,
          type: 'publication',
          title: "Conference Publications",
          icon: ['researcher'],
          style_title: "info-regular",
          style_content: "info-regular-pub",
          content: [
            {
              title: {
                en: "Mobile AR System for Detecting and Classifying Military Equipment Based on Deep Learning",
                ko: "딥러닝 기반 휴대형 증강현실 군용 장비 탐지 및 분류 시스템의 설계 및 구현"
              },
              author: {
                en: "<b>Younggeol Cho*</b>, Jaeheon Lee*, Kyeongha Rho* (*: equal contribution)",
                ko: "<b>조영걸*</b>, 이재헌*, 노경하* (*: 공동1저자)"
              },
              journal: {
                en: "Korea Institute of Military Science and Technology Annual Conference Proceedings 2020",
                ko: "2020 한국군사과학기술학회 종합학술대회"
              },
              page: "pp. 322-323",
              year: "Nov. 2020"
            },
            {
              title: {
                en: "High-Precision Glass-to-Glass Delay Measuring Instrument for Systems with Image Acquisition and Display",
                ko: "영상 획득 및 전시를 포함하는 시스템을 위한 고정밀 Glass-to-Glass 지연 시간 측정 장치 설계"
              },
              author: {
                en: "<b>Younggeol Cho</b>, Jihyeok Yun, Hyemin Chang, Joohong Yoon, Sukjong Kang",
                ko: "<b>조영걸</b>, 윤지혁, 장혜민, 윤주홍, 강석종"
              },
              journal: {
                en: "Korea Institute of Military Science and Technology Annual Conference Proceedings 2020",
                ko: "2020 한국군사과학기술학회 종합학술대회"
              },
              page: "pp. 364-365",
              year: "Nov. 2020"
            },
            {
              title: {
                en: "Design of Multi-Channel/High-Quality Video Streaming System Based on Commercial Standards for Ground Combat Platforms",
                ko: "지상 전투 플랫폼을 위한 상용 표준 기반 다채널/고품질 스트리밍 시스템 설계"
              },
              author: {
                en: "Jihyeok Yun, <b>Younggeol Cho</b>, Hyemin Chang, Joohong Yoon, Sukjong Kang",
                ko: "윤지혁, <b>조영걸</b>, 장혜민, 윤주홍, 강석종"
              },
              journal: {
                en: "Korea Institute of Military Science and Technology Annual Conference Proceedings 2020",
                ko: "2020 한국군사과학기술학회 종합학술대회"
              },
              page: "pp. 1299-1300",
              year: "Nov. 2020"
            },
          ]
        },
        {
          order: 1200,
          type: 'patent',
          title: "Patents",
          style_title: "info-regular",
          style_content: "info-regular-pub",
          content: [
            {
              title: {
                en: "Method and System for Service Connection Control",
                ko: "서비스 연결제어 방법 및 시스템"
              },
              author: {
                en: "Hyemin Chang, <b>Younggeol Cho</b>, Jihyeok Yun, Joohong Yoon, Sukjong Kang",
                ko: "장혜민, <b>조영걸</b>, 윤지혁, 윤주홍, 강석종"
              },
              reg_no: "10-2250169",
              holder: {
                en: "Agency for Defense Development",
                ko: "국방과학연구소"
              },
              year: "May. 2021",
              icon: ['researcher'],
            },
            {
              title: {
                en: "Apparatus and Method for Measuring Glass-to-Glass Delay of the System including Video Sensor and Display",
                ko: "영상 센서 및 전시기를 포함하는 시스템의 종단 화면 간 지연시간 측정 장치 및 그의 작동 방법"
              },
              author: {
                en: "Jihyeok Yun, <b>Younggeol Cho</b>, Hyemin Chang, Joohong Yoon, Sukjong Kang",
                ko: "윤지혁, <b>조영걸</b>, 장혜민, 윤주홍, 강석종"
              },
              holder: {
                en: "Agency for Defense Development",
                ko: "국방과학연구소"
              },
              reg_no: "10-2255411",
              year: "May. 2021",
              icon: ['researcher'],
            },
            {
              title: {
                en: "Umbrella Carrier for a Vehicle",
                ko: "운송수단용 우산 장착장치"
              },
              author: {
                en: "<b>Younggeol Cho</b>, Hyunjun Kim",
                ko: "<b>조영걸</b>, 김현준"
              },
              holder: '',
              app_no: "10-2016-0172170",
              year: "Dec. 2016",
              status: 'pending',
              style_badge: 'bgc-patent-pending',
              icon: ['maker'],
            },
          ]
        }
      ]}
  }
}
</script>

<style>
#app {
}

body {
  overflow: auto;
}

.nav-link.nav-item-pub {
}
</style>



// WEBPACK FOOTER //
// src/components/Publications.vue